// Quill

'use strict';

icing.watch('[data-toggle*="quill"]', editor => {
    import(/* webpackChunkName: 'quill' */ 'quill')
        .then(({default: Quill}) => {

            if (editor.nodeName === "TEXTAREA") {
                const newEditor = document.createElement('div');
                for (var i = 0; i < editor.attributes.length; i++) {
                    var attributeName = editor.attributes[i].name;
                    var attributeValue = editor.attributes[i].value;
                    if (attributeName === 'data-toggle') {
                        continue;
                    }
                    newEditor.setAttribute(attributeName, attributeValue);
                }
                newEditor.innerHTML = editor.value;

                editor.parentNode.replaceChild(newEditor, editor);
                editor = newEditor;
            }

            if (editor.hasAttribute('name')) {
                const input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', editor.getAttribute('name'));
                input.value = editor.value;

                editor.removeAttribute('name');
                editor.insertAdjacentElement("afterend", input)

                input.closest('form')
                    .addEventListener('submit',
                        (e) => {
                            input.value = editor.querySelector('.ql-editor').innerHTML;
                        }
                    )
            }


            const userOptions = editor.dataset.quill ? JSON.parse(editor.dataset.quill) : {};

            const defaultOptions = {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{header: [1, 2, 3, 4, 5, 6, false]}],
                        ['bold', 'italic', 'underline'],
                        ['link', 'blockquote', 'image'],
                        [
                            {list: 'ordered'},
                            {list: 'bullet'}
                        ]
                    ]
                }
            };

            const options = {
                ...defaultOptions,
                ...userOptions
            };

            new Quill(editor, options);

            window.Quill = Quill;
        })
        .catch(console.warn);
})

